import React, {useCallback, useState} from "react";
import {Section} from "../grouping/Section";
import {Button, Col, Form, FormCheck, FormControl, FormLabel, Row} from "react-bootstrap";
import {DataListView} from "../grouping/DataListView";
import {ModalPopUp} from "../grouping/ModalPopUp";
import {ModalContentContainer} from "../grouping/ModalContentContainer";
import {useForm} from "../../utilities/formutilities";
import {CLUB_EMPTY, useClubMutations, useClubs} from "../../api/clubapi";
import {ButtonLoading} from "../ButtonLoading";
import {useAuthenticated} from "../../contexts/authenticationcontext";
import {useSectors} from "../../api/sectorsapi";
import {LabelWithInput} from "../grouping/LabelWithInput";
import {FormSelectList} from "../FormSelectList";
import Collapse from "react-bootstrap/Collapse";
import {useMembersDetailed} from "../../api/memberapi";
import {BusyProvider, useBusyContext} from "../../contexts/busycontext";
import {MemberCoupling} from "../MemberCoupling";

export function ClubOption(props) {
    const {title} = props;
    const [open, setOpen] = useState(false);
    const [fileEditing, setFileEditing] = useState(undefined);
    const {clubs} = useClubs();
    const {sectorControl} = useAuthenticated();
    const {membersDetailed} = useMembersDetailed();
    const membersDetailedSectorControlFiltered = sectorControl === 'ALL' ? membersDetailed
        :
        membersDetailed?.filter(m => m.sector === sectorControl);
    const sectorsDetailedSectorControlFiltered = sectorControl === 'ALL' ? clubs
        :
        clubs?.filter(s => s.sector === sectorControl);
    return <Section title={title}>
        <Col xs={12} className={"text-end"}>
            <Button onClick={() => setOpen(true)}>Nieuw</Button>
        </Col>
        <DataListView title={"Club lijst"}
                      dataArray={sectorsDetailedSectorControlFiltered ? sectorsDetailedSectorControlFiltered : []}
                      onOpenChange={setOpen}
                      onItemEditChange={setFileEditing}
                      header={[{title: "Club", fieldName: "club"}, {
                          title: "Stamnr",
                          fieldName: "stamNummer"
                      }, {title: "Prov", fieldName: "provincie"}, {title: "Tel", fieldName: "telefoon"}, {
                          title: "Functie",
                          fieldName: "functieClub"
                      }, {title: "email", fieldName: "email"}]}
                      searchHeaders={[{title: "Club", fieldName: "club"}, {
                          title: "Stamnr",
                          fieldName: "stamNummer"
                      }, {title: "Prov", fieldName: "provincie"}, {title: "Tel", fieldName: "telefoon"}, {
                          title: "Functie",
                          fieldName: "functieClub"
                      }, {title: "Email", fieldName: "email"}, {title: "Sector", fieldName: "sector"}, {
                          title: "Actief",
                          fieldName: "active",
                          isBool: true,
                          default: 'both'
                      }]}/>

        <ModalPopUp open={open} onOpenChanged={setOpen}
                    modalContent={<FileOptionModalContent members={membersDetailedSectorControlFiltered}
                                                          sectorControl={sectorControl}
                                                          fileEditing={fileEditing}
                                                          setFileEditing={setFileEditing}
                                                          clubs={clubs}
                                                          onOpenChanged={setOpen}/>}/>


    </Section>


    function FileOptionModalContent(props) {
        const {fileEditing, onOpenChanged, setFileEditing, clubs, members} = props;
        const {busy, setIsBusy} = useBusyContext();
        const {sectors} = useSectors();
        const {createClub, editClub} = useClubMutations();
        const dateNow = new Date();
        const addOneYear = (dateNow.getDate() + '-' + dateNow.getMonth()) === '1-11' ? 1 : 0;
        const yearNowShort = (dateNow.getFullYear() + addOneYear).toString().substring(2, 4);
        const stamNummers = clubs?.map(c => c.stamNummer);
        const maxStamNummer = Math.max(...stamNummers);
        const nextStamNummer = isNaN(maxStamNummer) || !isFinite(maxStamNummer) ? '00' : (maxStamNummer + 1).toString().substring(2, 4);
        const initialObjectInintializer = useCallback(() => fileEditing ? {...fileEditing} : {
            ...CLUB_EMPTY,
            stamNummer: `${yearNowShort}${nextStamNummer}`
        }, [])


        const {
            tempObject,
            setTempObject,
            onChange
        } = useForm(initialObjectInintializer)


        async function handleCreateSubmit(e) {
            e.preventDefault();
            const result = await createClub(tempObject);
            onOpenChanged(false);
            setIsBusy(false);
        }

        async function handleEditSubmit(e) {
            e.preventDefault();
            const result = await editClub(tempObject);
            if (result) {
                onOpenChanged(false);
                setFileEditing(undefined);
            }
            setIsBusy(false);
        }

        return <ModalContentContainer onOpenChanged={onOpenChanged} onEditingChanged={setFileEditing}>

            <Section title={fileEditing ? "Wijzig club" : "Nieuwe club"}>
                <Row>
                    <Col xs={'auto'}>
                        <LabelWithInput title={"Provincie"}><FormControl value={tempObject.provincie}
                                                                         onChange={e => onChange(e, 'provincie')}/>
                        </LabelWithInput>
                    </Col>
                    <Col xs={'auto'}>
                        <LabelWithInput title={"Sector"}><FormSelectList value={tempObject?.sector}
                                                                         defaultValueText={'Selecteer sector'}
                                                                         dataList={sectors ? sectors?.map(s => s.sectorNaam) : []}
                                                                         onChange={e => {
                                                                             onChange(e, 'sector')

                                                                         }}/></LabelWithInput>
                    </Col>
                </Row>
                <Row>
                    <Col xs={4}>
                        <LabelWithInput title={"Stamnr"}><FormControl type={'number'}
                                                                      disabled={!tempObject.club?.includes('Individueel')}
                                                                      value={tempObject.stamNummer}
                                                                      onChange={e => onChange(e, 'stamNummer')}/></LabelWithInput>


                    </Col>
                    <Col xs={4}>
                        <LabelWithInput title={"Club"}><FormControl value={tempObject.club}
                                                                    onChange={e => onChange(e, 'club')}/></LabelWithInput>


                    </Col>
                    <Col xs={4}>
                        <LabelWithInput title={"Lokaal"}><FormControl value={tempObject.lokaal}
                                                                      onChange={e => onChange(e, 'lokaal')}/></LabelWithInput>


                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <LabelWithInput title={'Adres 1'}><FormControl value={tempObject.adres}
                                                                       onChange={e => onChange(e, 'adres')}/></LabelWithInput>

                    </Col>
                    <Col xs={6}>
                        <LabelWithInput title={'Adres 2'}><FormControl value={tempObject.adres2}
                                                                       onChange={e => onChange(e, 'adres2')}/></LabelWithInput>

                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <LabelWithInput title={'Telefoon'}><FormControl value={tempObject.telefoon}
                                                                        onChange={e => onChange(e, 'telefoon')}/></LabelWithInput>

                    </Col>



                    <Col xs={6}>
                        <LabelWithInput title={'Email'}><FormControl type={'email'} value={tempObject.email}
                                                                     onChange={e => onChange(e, 'email')}/></LabelWithInput>

                    </Col>
                </Row>


                <MemberCoupling onFileEditingChange={setFileEditing} members={members} itemEditing={fileEditing}
                                editItem={editClub} setTempObject={setTempObject}/>
                <Row>


                    <Col xs={6}>
                        <Section>
                            <Col xs={12}>
                                <FormLabel htmlFor={'actief'}>club actief? </FormLabel>
                            </Col>
                            <Col xs={'auto me-2'}>
                                <LabelWithInput title={'ja'}> <FormCheck id={'actiefJa'}
                                                                         name={'actief'}
                                                                         value={'true'}
                                                                         type={'radio'}
                                                                         defaultChecked={tempObject.active}
                                                                         onChange={e =>
                                                                             onChange(e, 'active')
                                                                         }/></LabelWithInput>

                            </Col>
                            <Col xs={'auto me-2'}>
                                <LabelWithInput title={'nee'}> <FormCheck id={'actiefNee'}
                                                                          def
                                                                          name={'actief'}
                                                                          value={'false'} type={'radio'}
                                                                          defaultChecked={!tempObject.active}
                                                                          onChange={e =>
                                                                              onChange(e, 'active')}/></LabelWithInput>
                            </Col>
                        </Section>
                    </Col>
                </Row>
                {fileEditing ?
                    <Col xs={6}>
                    </Col> : ""}
                <Col xs={fileEditing ? 6 : 12} className={"text-end mt-3"}>
                    <ButtonLoading title={"Opslaan"} isLoading={busy} onClick={(event) => {
                        setIsBusy(true);
                        fileEditing ? handleEditSubmit(event) : handleCreateSubmit(event)
                    }}/>
                </Col>

            </Section>

        </ModalContentContainer>
    }








    function LabelWithInput(props) {
        const {title, children, reverse} = props;
        return <Row className={'me-1 mt-1'}>
            {reverse ?
                <>
                    <Col xs={'auto'}>{children}</Col>
                    <Col>{title}</Col>
                </> :
                <>   <Col xs={'auto'}>{title}</Col>
                    <Col>{children}</Col> </>
            }

        </Row>
    }


}